// AI Question Generation Action Types

export const GENERATE_QUESTIONS_REQUEST = 'GENERATE_QUESTIONS_REQUEST';
export const GENERATE_QUESTIONS_SUCCESS = 'GENERATE_QUESTIONS_SUCCESS';
export const GENERATE_QUESTIONS_FAILURE = 'GENERATE_QUESTIONS_FAILURE';

export const FETCH_GENERATED_QUESTIONS_REQUEST = 'FETCH_GENERATED_QUESTIONS_REQUEST';
export const FETCH_GENERATED_QUESTIONS_SUCCESS = 'FETCH_GENERATED_QUESTIONS_SUCCESS';
export const FETCH_GENERATED_QUESTIONS_FAILURE = 'FETCH_GENERATED_QUESTIONS_FAILURE';

export const APPROVE_GENERATED_QUESTION = 'APPROVE_GENERATED_QUESTION';
export const REJECT_GENERATED_QUESTION = 'REJECT_GENERATED_QUESTION';
export const EDIT_GENERATED_QUESTION = 'EDIT_GENERATED_QUESTION';

export const UPDATE_GENERATED_PASSAGE = 'UPDATE_GENERATED_PASSAGE';
export const CLEAR_GENERATED_QUESTIONS = 'CLEAR_GENERATED_QUESTIONS';
